var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3337 44.3333C51.3337 45.571 50.842 46.758 49.9668 47.6332C49.0917 48.5083 47.9047 49 46.667 49H9.33366C8.09598 49 6.909 48.5083 6.03383 47.6332C5.15866 46.758 4.66699 45.571 4.66699 44.3333V11.6667C4.66699 10.429 5.15866 9.242 6.03383 8.36683C6.909 7.49167 8.09598 7 9.33366 7H21.0003L25.667 14H46.667C47.9047 14 49.0917 14.4917 49.9668 15.3668C50.842 16.242 51.3337 17.429 51.3337 18.6667V44.3333Z",
    fill: "#03565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.ac8090d45898468c78771200551d11a1.svg";
export { ForwardRef as ReactComponent };